var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-content__wrap",attrs:{"id":"app"}},[_c('ProgressBar'),_c('div',{staticStyle:{"max-width":"2560px","margin":"0 auto"}},[_c('Header'),_c('router-view'),_c('BackToTop'),_c('ButtonFly')],1),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }